import { DateTime } from 'luxon';
import * as superagent from 'superagent';
import {
    generateServerReadStateSlice,
    ServerRequestState as SliceServerRequestState,
} from 'dg-web-shared/lib/ServerRequestStateSlices';
import { requestV2 } from '../../AsyncRequest';
import { useStore } from 'dg-web-shared/lib/Flux';
import {
    RequestMethod,
    ServerRequestState,
    ServerWriteState,
    useServerSuccessEffect,
    useServerWrite,
} from 'dg-web-shared/lib/hooks/ServerStateHooks';
import {
    SavedCreditCardAliasResponse,
    SavedCreditCardAliasResponseTag,
} from 'dg-web-shared/model/PaymentAlias';

export namespace DeleteSavedCreditCardState {
    export type State = ServerRequestState<string, null>;
    export function use(
        onSuccess?: () => void,
    ): ServerWriteState<string, null, object> {
        const { update } = useStore(() => ({}));
        const [state, write, reset] = useServerWrite<object, string, null>(
            () => ({
                url: '/ui-api/customer-account/deposits/credit-card-alias',
                method: RequestMethod.DELETE,
            }),
        );

        useServerSuccessEffect(state, () => {
            update(SavedCreditCardState.refetch);
            if (onSuccess) {
                onSuccess();
            }
        });

        return [state, write, reset];
    }
}

export namespace SavedCreditCardState {
    export type State = SliceServerRequestState<SavedCreditCardAliasResponse>;

    export const { get, setResponse, refetch, use } =
        generateServerReadStateSlice<SavedCreditCardAliasResponse>({
            key: 'top-up-balance-methods-get-saved-cc-alias-remote-request',
            sideEffects(store, state) {
                if (state.shouldFetch) {
                    store.update(
                        requestV2(
                            () =>
                                superagent.get(
                                    '/ui-api/customer-account/deposits/credit-card-alias',
                                ),
                            setResponse,
                        ),
                    );
                }
            },

            parseBody(body: unknown): SavedCreditCardAliasResponse {
                const result = JSON.parse(JSON.stringify(body));
                const tag = result.tag as SavedCreditCardAliasResponseTag;

                if (
                    tag === SavedCreditCardAliasResponseTag.FOUND &&
                    !!result.creditCardAlias.expiration
                ) {
                    const upperBoundTime = DateTime.fromISO(
                        result.creditCardAlias.expiration.upperBoundDateTime,
                    );
                    if (
                        typeof result.creditCardAlias.expiration.isExpired ===
                        'undefined'
                    ) {
                        result.creditCardAlias.expiration.isExpired =
                            upperBoundTime < DateTime.local();
                    }
                }

                return result as SavedCreditCardAliasResponse;
            },
        });
}
